module.exports = __webpack_public_path__ + "img/p9-p1-tips1.51b1298d.png";